import { useDispatch } from 'react-redux';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { useMutation } from '@tanstack/react-query';
import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { ErrorResponse, globalErrorResponse, showNotification } from '../../store/notifications/actions';
import { useTranslation } from 'react-i18next';
import { removeProductFromCart } from './removeSingleProductFromCart';

export const useRemoveProductFromCart = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    return useMutation(removeProductFromCart, {
        onSuccess: (_, { title }) => {
            invalidateCartAggregations().then();
            invalidateShoppingCartProducts().then();
            invalidateCartGroupedItems().then();
            invalidateCartSummaryQuery().then();
            dispatch(showNotification(t('notifications.getMessageFromActionCart.remove', { productTitle: title })));
        },
        onError: (error: ErrorResponse) => {
            dispatch(globalErrorResponse(error));
        }
    });
};
